export function placeFromPublicData(data) {
  if (!data || typeof data !== 'object') return null
  if (data.place && typeof data.place === 'object') return data.place
  return data
}

function parseXFields(source) {
  if (!source) return {}
  if (typeof source === 'object') return source
  try {
    const parsed = JSON.parse(source)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (error) {
    return {}
  }
}

function unwrapXField(value) {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value !== 'object') return ''
  // Formato canônico: `{ type, value }`. `label` é legado (valor antigo).
  if (value.value && typeof value.value === 'object' && value.value.filepath) {
    return `${value.value.filepath}${value.value.name || ''}`
  }
  if (typeof value.value === 'string') return value.value
  if (value.value != null && typeof value.value !== 'object') {
    return String(value.value)
  }
  if (typeof value.filepath === 'string') {
    return `${value.filepath}${value.name || ''}`
  }
  if (typeof value.label === 'string') return value.label
  if (value.label && typeof value.label === 'object' && value.label.filepath) {
    return `${value.label.filepath}${value.label.name || ''}`
  }
  return ''
}

export function readPublicXField(data, ...keys) {
  const place = placeFromPublicData(data)
  if (!place) return ''

  const xfields = parseXFields(place.xfields)
  for (const key of keys) {
    if (xfields[key] != null && xfields[key] !== '') {
      return unwrapXField(xfields[key])
    }
    if (place[key] != null && place[key] !== '' && key !== 'xfields') {
      return unwrapXField(place[key])
    }
  }
  return ''
}

export function publicLogoSource(data) {
  const src = readPublicXField(data, 'logotipo', 'Logotipo').trim()
  if (!src) return null
  if (/^https?:\/\//i.test(src)) return { type: 'url', src }
  return { type: 'path', src }
}
